// PromoBanner reducer

import { initializeState } from '../../../utilities/storageUtils';
import promoBannerActionTypes from './promoBanner.types';

const INITIAL_STATE = {
  confirmation: null,
  isDismissed: false,
  searchKey: null,
  searchToken: 0
};

const promoBannerReducer = (state, action) => {
  state = initializeState(state, INITIAL_STATE);

  switch (action.type) {
    case promoBannerActionTypes.SET_PROMO_BANNER_CONFIRMATION:
      return {
        ...state,
        confirmation: action.confirmation,
        isDismissed: false,
        searchKey: action.searchKey ?? null
      };
    case promoBannerActionTypes.DISMISS_PROMO_BANNER_CONFIRMATION:
      return {
        ...state,
        isDismissed: true
      };
    case promoBannerActionTypes.CLEAR_PROMO_BANNER_CONFIRMATION:
      return { ...INITIAL_STATE, searchToken: state.searchToken };
    case promoBannerActionTypes.BUMP_PROMO_SEARCH_TOKEN:
      return { ...state, searchToken: state.searchToken + 1 };
    default:
      return state;
  }
};

export default promoBannerReducer;
